import { Injectable } from "@angular/core";

import { MapperInterface } from "../mapper-inteface";

import { ClassificaGescorDTO } from "@app/shared/dto/gescor/classifica-gescorDTO";

import { ClassificaGescorVO } from "@app/shared/vo/gescor/classifica-gescorVO";

@Injectable({
  providedIn: "root",
})
export class MapperClassificaGescor
  implements MapperInterface<ClassificaGescorDTO, ClassificaGescorVO> {
  convertVoToDto(t: ClassificaGescorVO): ClassificaGescorDTO {
    const classificaDTO = new ClassificaGescorDTO();
    if (t !== null && t !== undefined) {
      classificaDTO.denominazione = t.denominazione;
      classificaDTO.abilitaInvioComunicazioniDipendenti =
        t.abilitaInvioComunicazioniDipendenti;
      classificaDTO.livello = t.livello;
    }
    return classificaDTO || new ClassificaGescorDTO();
  }
  convertDtoToVo(t: ClassificaGescorDTO): ClassificaGescorVO {
    const classificaVO = new ClassificaGescorVO();
    if (t !== null && t !== undefined) {
      classificaVO.denominazione = t.denominazione;
      classificaVO.abilitaInvioComunicazioniDipendenti =
        t.abilitaInvioComunicazioniDipendenti;
      classificaVO.livello = t.livello;
      classificaVO.output = t.livello + " - " + t.denominazione;
      classificaVO.codice = t.livello;
    }
    return classificaVO || new ClassificaGescorVO();
  }
  convertListVoToDto(e: ClassificaGescorVO[]): ClassificaGescorDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: ClassificaGescorDTO[]): ClassificaGescorVO[] {
    if (t != null) {
      return t.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
  constructor() {}
}
